import React, {
  createContext,
  useCallback,
  useContext,
  useState,
  ReactNode,
} from 'react';

interface SpinContextType {
  loading: boolean;
  showSpin: () => void;
  hideSpin: () => void;
}

interface SpinProviderProps {
  children: ReactNode;
}

// Create the context
const SpinContext = createContext<SpinContextType>(undefined);

// Custom hook to use the Spin context
export const useSpin = (): SpinContextType => {
  const context = useContext(SpinContext);
  if (context === undefined) {
    throw new Error('useSpin must be used within a SpinProvider');
  }
  return context;
};

// Provider component
export const SpinProvider: React.FC<SpinProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);

  // Show the spinner
  const showSpin = useCallback(() => {
    setLoading(true);
  }, []);

  // Hide the spinner
  const hideSpin = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <SpinContext.Provider value={{ loading, showSpin, hideSpin }}>
      {children}
    </SpinContext.Provider>
  );
};
